//@flow
//Action Type Registered
export const KRATOS_INV_SUBMIT_SUCCESS='KRATOS_INV_SUBMIT_SUCCESS'
export const KRATOS_INV_SUBMIT_ERROR='KRATOS_INV_SUBMIT_ERROR'
export const KRATOS_INV_SUBMITTED_COMPLETED='KRATOS_INV_SUBMITTED_COMPLETED'
export const KRATOS_EDIT_VERIFY_FORM_DATA_SUCCESS='KRATOS_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const KRATOS_EDIT_VERIFY_FORM_DATA_ERROR='KRATOS_EDIT_VERIFY_FORM_DATA_ERROR'
export const KRATOS_UPDATE_FORM_ERROR='KRATOS_UPDATE_FORM_ERROR'
export const REFRESH_KRATOS_CACHE_VALUE='REFRESH_KRATOS_CACHE_VALUE'

export const KRATOS_PANEL_PDF_CONTENT='KRATOS_PANEL_PDF_CONTENT'
export const KRATOS_PANEL_FORM_INFO='KRATOS_PANEL_FORM_INFO'
export const KRATOS_PANEL_EXCEPTION_FORM_INFO='KRATOS_PANEL_EXCEPTION_FORM_INFO'
export const KRATOS_PANEL_PROPERTY_INFO='KRATOS_PANEL_PROPERTY_INFO'
export const KRATOS_PANEL_BILLCONTACT_INFO='KRATOS_PANEL_BILLCONTACT_INFO'
export const KRATOS_PANEL_EXEMPTREQ_INFO='KRATOS_PANEL_EXEMPTREQ_INFO'
export const KRATOS_PANEL_UNIT_INFO_1='KRATOS_PANEL_UNIT_INFO_1'
export const KRATOS_PANEL_UNIT_INFO_2='KRATOS_PANEL_UNIT_INFO_2'
export const KRATOS_PANEL_UNIT_INFO_3='KRATOS_PANEL_UNIT_INFO_3'
export const KRATOS_PANEL_UNIT_INFO_4='KRATOS_PANEL_UNIT_INFO_4'
export const KRATOS_PANEL_UNIT_INFO_5='KRATOS_PANEL_UNIT_INFO_5'
export const KRATOS_PANEL_SIGNATURE_INFO='KRATOS_PANEL_SIGNATURE_INFO'
export const KRATOS_PANEL_EMERGENCY_CONTACT_INFO='KRATOS_PANEL_EMERGENCY_CONTACT_INFO'
export const KRATOS_PANEL_REGISTRANT_INFO='KRATOS_PANEL_REGISTRANT_INFO'
export const KRATOS_PANEL_FORM_PAGE_INFO='KRATOS_PANEL_FORM_PAGE_INFO'
export const KRATOS_PANEL_REVIEW_QUESTIONS='KRATOS_PANEL_REVIEW_QUESTIONS'


// WEBPACK FOOTER //
// ./src/redux/kratos/actionTypes.js